import { Accessor, Match, Switch } from "solid-js";
import {
  axisFloorBgDesktop,
  tdFloorBgDesktop,
  tdFloorBgMob,
} from "~/assets/assets";
import { clientIdConfig } from "~/data/partner_config";

export function LoginPageFooter$Client(props: {
  clientId: Accessor<string | undefined>;
}) {
  return (
    <Switch>
      <Match when={props.clientId() === clientIdConfig.axisClientId}>
        <div
          class="fixed bottom-0 -z-10 flex h-[200px] w-full sm:h-[338px] "
          style={`
           background-image: url(${axisFloorBgDesktop});
          background-size: 100% 100%;
          `}
        ></div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.tdClientId}>
        <div
          class="fixed bottom-0 -z-10 hidden h-[200px] w-full bg-cover sm:h-[330px] md:flex"
          style={`
                     background-image: url(${tdFloorBgDesktop});
                    `}
        ></div>
        <div
          class="fixed bottom-0 -z-10 h-[300px] w-full bg-cover md:hidden"
          style={`
                     background-image: url(${tdFloorBgMob});
                    `}
        ></div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.bajajClientId}>
        <div
          class="fixed bottom-0 -z-10 hidden h-[200px] w-full bg-cover sm:h-[330px] md:flex"
          style={`
                     background-image: url(${tdFloorBgDesktop});
                    `}
        ></div>
        <div
          class="fixed bottom-0 -z-10 h-[300px] w-full bg-cover md:hidden"
          style={`
                     background-image: url(${tdFloorBgMob});
                    `}
        ></div>
      </Match>
    </Switch>
  );
}
